import { observer } from 'mobx-react-lite';
import React, { Fragment, useContext } from 'react';
import { Message } from 'semantic-ui-react';

import { RootStoreContext } from '../../../app/stores/rootStore';

const Information: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { information } = rootStore.informationStore;

  return (
    <Fragment>
      <Message info size='tiny'>
        <Message.Header>お知らせ</Message.Header>
        {information.map((info, i) => (
          <Message.List key={i}>
            <Message.Item>{info}</Message.Item>
          </Message.List>
        ))}
      </Message>
    </Fragment>
  );
};

export default observer(Information);
